import { memo } from 'react';
import PropTypes from 'prop-types';
import condStrings from '../../utils/condStrings';

import styles from './formattedText.module.sass';
import { formatTextToHtmlString } from '../../utils/formatText';

const FormattedText = (props) => {
  const { className, text, ...rest } = props;

  return (
    <div
      {...rest}
      className={condStrings(styles.root, className)}
      dangerouslySetInnerHTML={{
        __html: formatTextToHtmlString(text, { replaceBreakLines: false }),
      }}
    />
  );
};

FormattedText.defaultProps = {
  className: '',
  text: '',
};

FormattedText.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
};

export default memo(FormattedText);
